import { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  addStatus,
  getStatuss,
  getStatus,
  editStatus,
  deleteStatus,
  getAllStatuss,
} from "../../store/actions/status_action";
import _debounce from "lodash/debounce";
// import { useSelectAllIndustry } from "./UseIndustry";

// Get All Data
export const useAllStatuss = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.status);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
  const [reloadData, setReloadData] = useState(false);

  useEffect(() => {
    if (deleteEntry) {
      dispatch(deleteStatus(deleteEntry));
    }
    allQuery();
  }, [deleteEntry, pageNumber, window.location.search]);
  const allQuery = useCallback(
    _debounce(() => {
      dispatch(
        getStatuss({
          pageNumber,
        })
      );
    }, 1000),
    []
  );

  useEffect(() => {
    setPageNumber(1);
  }, [window.location.search]);

  useEffect(() => {
    if (reloadData) {
      allQuery();
      setReloadData(false);
    }
  }, [reloadData]);

  const deleteBtnClicked = async (id) => {
    setDeleteEntry(id);
  };

  return [data, setPageNumber, deleteBtnClicked, setReloadData];
};

// Get Single Data
export const useSingleStatus = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.status);
  useEffect(() => {
    dispatch(getStatus(id));
  }, [id]);
  return [data];
};
// Add Data
export const useCreateStatus = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.status);
  const addData = async (data) => {
    await dispatch(addStatus(data));
  };
  return [data, addData];
};
export const useUpdateStatus = () => {
  const dispatch = useDispatch();
  // const data = useSelector((state) => state.status);
  const updateData = async (id, data) => {
    await dispatch(editStatus(id, data));
  };
  return [updateData];
};

export const useSelectAllStatus = () => {
  const dispatch = useDispatch();
  const [term, setTerm] = useState("");
  const [value, setValue] = useState("");
  const data = useSelector((state) => state.status);
  useEffect(() => {
    dispatch(getAllStatuss({ term, value }));
  }, [term, value]);
  return [data, setTerm, setValue];
};

export const useGetDropdownOptions = () => {
  //  const [client, setClientSearchField, setClientSearchValue] =
  // useSelectAllClient();

  const [dropdownOptions, setDropdownOptions] = useState({});
  // useEffect(() => {
  //   if (industry && industry.all_industrys) {
  //     const newData = industry.all_industrys.map((item) => {
  //       return { label: item.name, value: item.name };
  //     });
  //     setDropdownOptions({ ...dropdownOptions, industry: newData });
  //   }
  // }, [industry]);

  return [
    dropdownOptions,
    // setClientSearchField, setClientSearchValue
  ];
};
